<ion-button fill="clear" expand="block" class="web">
  Actualizar
  <ion-icon slot="end" name="refresh-outline"></ion-icon>
</ion-button>
